import { render, staticRenderFns } from "./FaultsHistory.vue?vue&type=template&id=d5c54920&scoped=true"
import script from "./FaultsHistory.vue?vue&type=script&lang=js"
export * from "./FaultsHistory.vue?vue&type=script&lang=js"
import style0 from "./FaultsHistory.vue?vue&type=style&index=0&id=d5c54920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c54920",
  null
  
)

export default component.exports